<div class="ngxdt audit-logs position-relative">
    <div class="table-shimmer" *ngIf="dataService.isLoading">
      <div class="shimmer-row" *ngFor="let item of shimmerRows">
        <span class="bone sn"></span>
        <span class="bone"></span>
        <span class="bone short"></span>
        <span class="bone"></span>
        <span class="bone long"></span>
        <span class="bone long"></span>
        <span class="bone"></span>
        <span class="bone pill"></span>
        <span class="bone short"></span>
        <span class="bone icon"></span>
        <span class="bone icon"></span>
      </div>
    </div>

    <div class="ngxdt-header active-log px-2">
    </div>

    <div class="ngxdt-body" [class.is-loading]="dataService.isLoading">
        <ngx-datatable #table class="bootstrap" 
         [headerHeight]="50"
         [footerHeight]="50"
         [rowHeight]="'auto'"
         [messages]="{
           emptyMessage: ngxDatatableSSRConfig.emptyMessage,
           totalMessage: ngxDatatableSSRConfig.totalMessage,
           selectedMessage: false
         }" 
         [footerHeight]="ngxDatatableSSRConfig.footerHeight" 
         [limit]="ngxDatatableSSRConfig.pageSize" 
         [rows]="rows"
         [columnMode]="'flex'" 
         [offset]="ngxDatatableSSRConfig.tableOffset" 
         [loadingIndicator]="false"
         [scrollbarH]="true"
         [scrollbarV]="true"
         [selectionType]="'row'"
         [virtualization]="false">
            <ngx-datatable-column *ngFor="let column of columns"
                [flexGrow]="column.flexGrow"
                [minWidth]="column.minWidth" 
                [prop]="column.prop"
                [name]="column.name"
                [sortable]="column.sortable"
                [resizable]="false"
                [draggable]="false"
                [headerClass]="column.alignCenter ? 'text-center-ngx' : ''"
                [cellClass]="column.alignCenter ? 'text-center-ngx' : ''"
                >
                <ng-template  ngx-datatable-header-template let-sort="sortFn" let-sortDir="sortDir">
                    <div class="d-flex align-items-center cursor-pointer datatable-header-cell-label draggable w-100" (click)="sort()" [ngClass]="{'justify-content-center': column.alignCenter}">
                      <span>{{ column.name }}</span>
                      <span class="ms-1">
                        <ng-container *ngIf="column?.sortable==true" [ngSwitch]="sortDir">
                          <span *ngSwitchCase="'asc'">↑</span>
                          <span *ngSwitchCase="'desc'">↓</span>
                          <span *ngSwitchDefault>⇅</span>
                        </ng-container>
                      </span>
                    </div>
                  </ng-template>
                <!-- [sortable]="column.sortable"
                [draggable]="column.draggable" -->
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                   <ng-container *ngIf="value === '(No Phone)' && column.prop === 'phoneNumber'">
                    <a>
                        {{ sanitizeNumber(value) }}
                    </a>
                   </ng-container>
                   <ng-container *ngIf="value != '(No Phone)' && column.prop === 'phoneNumber'">
                    <a [href]="sanitizeValue(value)" target="_blank">
                        {{ sanitizeNumber(value) }}
                    </a>
                   </ng-container>

                    <div *ngIf="column.prop !== 'sortableDate' && !column.cellTemplate && column.prop !== 'phoneNumber' && column.prop !== 'registeredStaffCount'" class="text-truncate overflow-hidden w-100" [ngClass]="{'text-center': column.alignCenter}">{{ (value !== null && value !== undefined) ? value : column.defaultValue }}</div>
                    
                    <div *ngIf="column.prop === 'registeredStaffCount' && !column.cellTemplate" class="text-truncate overflow-hidden w-100" [ngClass]="{'text-center': column.alignCenter}">
                      <ng-container *ngIf="(value !== null && value !== undefined ? value : column.defaultValue) === 0">
                        <span>{{ (value !== null && value !== undefined) ? value : column.defaultValue }}</span>
                      </ng-container>
                      <ng-container *ngIf="(value !== null && value !== undefined ? value : column.defaultValue) !== 0">
                        <a (click)="registeredStaffClick(row)" class="cursor-pointer text-primary text-decoration-underline">{{ (value !== null && value !== undefined) ? value : column.defaultValue }}</a>
                      </ng-container>
                    </div>
                    <div *ngIf="column.prop == 'sortableDate' && !column.cellTemplate && column.prop !== 'phoneNumber'" class="text-truncate overflow-hidden">{{ row.date }}</div>

                    <div *ngIf="column.cellTemplate">
                        <app-edit-delete-icon [row]="row" [column]="column"
                         (onChanged)="onChanged($event)" 
                         (deletedRowData)="onDelete($event)"
                         (editedRowData)="editedRowData($event)"
                         (previewRowData)="previewRowData($event)"
                         >
                        </app-edit-delete-icon>
                    </div>
                    <div *ngIf="column.device && !column.cellTemplate">
                        <app-edit-delete-icon [row]="row" [column]="column">
                        </app-edit-delete-icon>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-footer>
                <ng-template *ngIf="footerShow" ngx-datatable-footer-template>
                    <div class="d-flex w-100 align-items-center justify-content-between">
                        <div class="page-size-control p-t-7px">
                            <div class="text-nowrap f-11 text-black-color"> Showing <span class="font-semibold">1</span> to <span
                                    class="font-semibold">
                                    <select class="page-size-dropdown" [(ngModel)]="ngxDatatableSSRConfig.pageSize"
                                        (ngModelChange)="onPageSizeChanged($event)">
                                        <option *ngFor="let opt of ngxDatatableSSRConfig.limitOptions" [ngValue]="opt.value">
                                            {{opt.key}}
                                        </option>
                                    </select>
                                </span> of <span class="font-semibold">{{ ngxDatatableSSRConfig?.totalRecords}}</span> entries</div>
                        </div>
                        <div class="pagination-control pe-5">
                            <ngb-pagination #ngbPage [boundaryLinks]="false" [collectionSize]="ngxDatatableSSRConfig.totalRecords"
                                [pageSize]="ngxDatatableSSRConfig.pageSize == 1?ngxDatatableSSRConfig.totalRecords:ngxDatatableSSRConfig.pageSize"
                                [page]="ngxDatatableSSRConfig.currentPageNumber" [maxSize]="5" (pageChange)="onPageChanged($event)">
                                <ng-template ngbPaginationPrevious>
                                    <img width="12" height="12" src="./../../../../assets/svg/LeftArrow.svg" alt="">
                                </ng-template>
                                <ng-template ngbPaginationNext>
                                    <img width="12" height="12" src="./../../../../assets/svg/RightArrow.svg" alt="">
                                </ng-template>
                            </ngb-pagination>
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-footer>

        </ngx-datatable>
    </div>
    <div class="ngxdt-footer">
    </div>
</div>